import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import styled from 'styled-components';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import UICheckbox from 'UIComponents/input/UICheckbox';
import FilterToggleGroup from './filterToggleGroup/FilterToggleGroup';
import { OptionGroupText } from './filterToggleGroup/FilterOption';
import * as TierGroup from '../../constants/groupTags/TierGroups';

/* Ensure consistent order */
const tierGroupNames = ['CRM', 'MARKETING', 'SALES', 'SERVICE', 'CMS', 'OPERATIONS'];

function getTierOption(tier) {
  return {
    text: unescapedText(`marketplace-ui-common.groupTags.tier.${tier}`),
    value: tier
  };
}

function getTierOptions(validTierGroups) {
  const validTierGroupNames = validTierGroups ? tierGroupNames.filter(group => validTierGroups.includes(group)) : tierGroupNames;
  return validTierGroupNames.map(group => {
    const tiers = TierGroup[group];
    if (tiers.length === 1) return getTierOption(tiers[0]);
    return {
      options: tiers.map(getTierOption),
      flatLayout: true,
      text: unescapedText(`marketplace-ui-common.groupTags.tierHub.${group}`)
    };
  });
}

const StyledPlanCompatibilityFilter = styled.div.withConfig({
  displayName: "PlanCompatibilityFilter__StyledPlanCompatibilityFilter",
  componentId: "sc-1ysabeu-0"
})(["& ", "{font-weight:600;}"], OptionGroupText);
export default function PlanCompatibilityFilter({
  ariaLabel,
  appContext,
  onChange,
  validTierGroups,
  value
}) {
  const {
    portalCompatible,
    tiers
  } = value;

  const handleTierChange = event => {
    const eventValue = event.target.value;
    const newValue = {
      portalCompatible: false,
      tiers: eventValue
    };
    onChange(SyntheticEvent(newValue, event.source));
  };

  const handleCompatibilityChange = event => {
    const newValue = event.target.checked ? {
      portalCompatible: true,
      tiers: []
    } : {
      portalCompatible: false,
      tiers
    };
    onChange(SyntheticEvent(newValue, event));
  };

  const isInApp = appContext === 'app';
  return /*#__PURE__*/_jsxs(StyledPlanCompatibilityFilter, {
    children: [isInApp && /*#__PURE__*/_jsx(UICheckbox, {
      checked: portalCompatible,
      onChange: handleCompatibilityChange,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-common.compatibility.planCompatibilityFilter.portalCompatible"
      })
    }), /*#__PURE__*/_jsx(FilterToggleGroup, {
      ariaLabel: ariaLabel,
      disabled: portalCompatible,
      multi: true,
      name: "plan-compatibility-filter",
      onChange: handleTierChange,
      options: getTierOptions(validTierGroups),
      value: tiers
    })]
  });
}